export function normalizePlaceholderKey(value) {
    return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');
}

export function getPlaceholderValue(source, requestedKey) {
    if (!source || typeof source !== 'object' || !requestedKey) return undefined;

    if (Object.prototype.hasOwnProperty.call(source, requestedKey)) {
        return source[requestedKey];
    }

    const normalizedRequestedKey = normalizePlaceholderKey(requestedKey);
    const matchingKey = Object.keys(source).find(
        key => normalizePlaceholderKey(key) === normalizedRequestedKey
    );

    return matchingKey === undefined ? undefined : source[matchingKey];
}
